// extracted by mini-css-extract-plugin
export default {"root":"OygDUD","inner":"lWDBBG","header":"c4AO3u","logo":"fcskm0","icons":"uuAhbT","content":"nNu_Wx","sidebar":"rpC_xY"};